var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMaison = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    fill: "none",
    viewBox: "0 0 18 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 1.14 7.608 5.412H14.1v6.341H3.9V6.552H1.392zM9 0c-.24 0-.468.077-.672.221L.408 5.855c-.792.597-.348 1.803.672 1.803h1.632v5.29c0 .576.492 1.052 1.116 1.052h10.38c.612 0 1.116-.465 1.116-1.051v-5.29h1.632c1.008 0 1.464-1.207.672-1.804L9.672.22A1.13 1.13 0 0 0 9 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.936 8.953c.06 0 .12.045.12.111v3.83h-2.1v-3.83c0-.055.048-.11.12-.11h1.872m-.012-1.107H8.064c-.732 0-1.32.542-1.32 1.217V14h4.5V9.064c0-.675-.588-1.217-1.32-1.217z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v14H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMaison);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Maison.d05d7c2534dd339875b73ed3c2048f49.svg";